import React from 'react';
import type { AppointmentSlot } from '@/common/api/models/appointmentSlot';
import SlotCreateForm from './SlotCreateForm';
import SlotEditView from './SlotEditView';

interface SlotFormProps {
  date?: Date;
  slot?: AppointmentSlot;
  viewMode?: 'month' | 'week';
  onSuccess: () => void;
  existingSlots?: AppointmentSlot[];
}

/**
 * SlotForm - Main component that handles both slot creation and editing.
 */
const SlotForm: React.FC<SlotFormProps> = ({
  date, slot, viewMode, onSuccess, existingSlots = [],
}) => {
  if (slot) {
    return <SlotEditView slot={slot} onSuccess={onSuccess} />;
  }

  return (
    <SlotCreateForm
      date={date}
      viewMode={viewMode}
      onSuccess={onSuccess}
      existingSlots={existingSlots}
    />
  );
};

export default SlotForm;
